import React from 'react';
import PropTypes from 'prop-types';

import AlertRules from './AlertRules';
import AlertIncidents from './AlertIncidents';
import { PageHeader } from '../../../components/PageHeader';
import { Button } from '../../../components/PageHeader/Button';
import Strings from '../../../Strings';
import { Tabs, Tab } from '../../../components/Tabs';

import './MessagesOverview.scss';

export const RULES_TAB = 'rules';
export const INCIDENTS_TAB = 'incidents';

function AlertsTabs(props) {
  const { match } = props;
  const tab = match?.params?.tab;
  const [refreshTimestamp, setRefreshTimestamp] = React.useState(0);
  const [activeIndex, setActiveIndex] = React.useState(tab === INCIDENTS_TAB ? 1 : 0);

  const pageHeaderRightPart = <Button class="refresh" onClick={() => setRefreshTimestamp(Date.now())} />;

  return (
    <>
      <PageHeader left={Strings.healthMonitorAlerts.title} right={pageHeaderRightPart} />
      <div className="health-messages__subtitle health-messages__subtitle--page">
        {Strings.healthMonitorAlerts.description}
      </div>
      <Tabs defaultIndex={activeIndex} onChange={i => setActiveIndex(i)}>
        <Tab label={Strings.healthMonitorAlerts.rules} path="/superuser-health/alerts/rules" key={RULES_TAB}>
          <AlertRules refreshTimestamp={refreshTimestamp} />
        </Tab>
        <Tab
          label={Strings.healthMonitorAlerts.incidents}
          path="/superuser-health/alerts/incidents"
          key={INCIDENTS_TAB}
        >
          <AlertIncidents refreshTimestamp={refreshTimestamp} />
        </Tab>
      </Tabs>
    </>
  );
}

AlertsTabs.propTypes = {
  activeTab: PropTypes.string,
  match: PropTypes.shape({
    params: PropTypes.shape({
      tab: PropTypes.string,
    }),
  }),
};

export default AlertsTabs;
